import React from 'react';
import { components } from 'react-select';

export const CustomOption = (props = {}) => {
  const { label, value } = props;
  const { matched_substrings: chunks, place_id } = value;

  // highlight text
  let start = 0;
  let end = 0;
  chunks.forEach((match, i) => {
    if (0 === i) {
      start = match.offset;
      end = match.length;
    }
    end = match.offset + match.length;
  });
  const previousLetter = start > 0 && label.substr(0, start);
  const boldLetters = label.substring(start, end);
  const remainingLetters = label.substring(
    boldLetters.length + start,
    label.length
  );

  return (
    <components.Option
      key={place_id}
      {...props}
      style={{ margin: 0, padding: 0 }}
    >
      {previousLetter && (
        <span className='text-gray-500'>{previousLetter}</span>
      )}
      <b style={{ fontWeight: 500 }} className='text-gray-900 heavier'>{boldLetters}</b>
      <span>{remainingLetters}</span>
    </components.Option>
  );
};
